import { createStyles, fade, makeStyles, Theme } from '@material-ui/core/styles';
import { colorsPalette, MIDDLE_MARGIN, SMALL_MARGIN } from '../../../../theme';

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    wrapper: {
      width: '100%',
    },
    col: {
      width: '100%',
      display: 'flex',
      flexDirection: 'column',
      marginBottom: MIDDLE_MARGIN,
      [theme.breakpoints.up('lg')]: {
        flexDirection: 'row',
        alignItems: 'flex-start',
      },
    },
    input: {
      width: '100%',
      '&:first-child': {
        marginBottom: MIDDLE_MARGIN,
      },
      [theme.breakpoints.up('lg')]: {
        flex: 1,
        width: `calc(50% - ${SMALL_MARGIN / 2})`,
        marginBottom: 0,
        '&:first-child': {
          marginRight: SMALL_MARGIN / 2,
          marginBottom: 0,
        },
        '&:last-child': {
          marginLeft: SMALL_MARGIN / 2,
        },
      },
    },
    chipRoot: {
      backgroundColor: 'transparent',
    },
    chipLabel: {
      fontSize: 16,
      lineHeight: 1,
      color: colorsPalette.gray,
    },
    chipDeleteIcon: {
      width: 16,
      height: 16,
      padding: 4,
      borderRadius: '50%',
      color: colorsPalette.white,
      '&:hover': {
        backgroundColor: fade(colorsPalette.white, 0.08),
      },
    },
    btn: {
      minWidth: 150,
      [theme.breakpoints.down('xs')]: {
        width: '100%',
      },
    },
  }),
);

export default useStyles;
